import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const RadiusNASRoutes = defineRoute({
    record: {
        route: {
            path: "/radius-nas",
            component: () => loadView(import("./RadiusNASTable.vue")),
        },
    },
    create: {
        route: {
            path: "/radius-nas/create",
            component: () => loadView(import("./RadiusNASCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/radius-nas/update/:id",
            component: () => loadView(import("./RadiusNASUpdate.vue")),
        },
        build(id: string) {
            return `/radius-nas/update/${id}`;
        },
    },
});
